import Vue from 'vue';
import Vuex from 'vuex';
import {
  routers
} from '../router/router';
import axios from 'axios';
import VueCookies from 'vue-cookies'

const myRouter = routers;
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 菜单列表
    menuList: [],
    // 菜单树
    menuListTree: [],
    // iframesrc: "#/Index",
    // 已打开菜单
    openmuenlist: [],
    // 当前打开的菜单的页面
    openmenupage: "",
  },
  mutations: {
    // 关闭单个菜单时删除菜单
    closeopenmenu(state, val) {
      state.openmuenlist = state.openmuenlist.filter(item => item.tabMenuID != val);
    },
    //关闭全部
    closeallopenmenu(state, val) {
      state.openmuenlist = [];
    },
    // 保留当前菜单
    closebaocunopenmenu(state, val) {
      state.openmuenlist = state.openmuenlist.filter(item => item.tabMenuID == val);
    },
    ontabmenuclick(state, val) {
      state.openmenupage = val;
      VueCookies.set("MenuInfo", {
        MenuID: val.replace('tabifmara_', ''),
        HTTPURL: "",
        title: ""
      }, 0, "/");
    },
    // 选择菜单时打开新窗口 val 格式{MenuID:"",HTTPURL:"",title:""} title 可不填
    changeiframesrc(state, val) {
      // 变更状态
      VueCookies.set("MenuInfo", val, 0, "/");
      //陈攀修改为兼容旧的网站
      if (val.HTTPURL.search("http") != -1) {
        let CommunityID = VueCookies.get("CommunityID");
        let MenuID = val.MenuID;
        let url = encodeURIComponent(val.HTTPURL);
        let access_token = VueCookies.get("access_token");
        // let httpIp1 = val.HTTPURL.match(/(\S*)\\/)[1];
        let httpIp1 = val.HTTPURL.split("/");
        let httpIP = httpIp1[0] + "//" + httpIp1[2];
        val.HTTPURL = httpIP + '/Home/RedirectTo/?access_token=' + access_token + '&MenuID=' + MenuID + '&TargetURL=' + url;
      }
      // 菜单中iframe的Id，关闭菜单时同时删除iframe
      val["tabMenuID"] = "tabifmara_" + val.MenuID;
      // 从菜单列表中获取菜单名称
      let nemutitle = state.menuList.filter(item => item.MenuID == val.MenuID);
      // 判断已存在菜单，存在刷新，不存在添加
      let seachval = state.openmuenlist.filter(item => item.tabMenuID == val.tabMenuID);
      if (val.MenuID == "0") {
        val["title"] = "首页";
      } else {
        if (val["title"] == undefined || val["title"] == null)
          val["title"] = nemutitle[0].title;
      }

      //设置打开的菜单页面
      state.openmenupage = "0";
      setTimeout(function () {
        state.openmenupage = val["tabMenuID"];
      }, 50);
 
      if (seachval.length <= 0) {
        state.openmuenlist.push(val);
      } else {
        if (document.getElementById(val["tabMenuID"]) != null && document.getElementById(val["tabMenuID"]) != undefined) {
          // document.getElementById(val["tabMenuID"]).src = "";
          document.getElementById(val["tabMenuID"]).src = val.HTTPURL;
          document.getElementById(val["tabMenuID"]).contentWindow.location.reload(true);
        }
      }
    },
    SetMenu(state, menulist) {
      if (menulist.length <= 0 || menulist == null || menulist == undefined) {
        state.menuList = [];
        state.menuListTree = [];
        return;
      }
      state.menuList = menulist;

      menulist.splice(0, 1);
      var rootParentIdValue = menulist[0].ParentID;
      var parentIdName = "ParentID";
      var nodeIdName = "MenuID";
      var ListData = menulist;

      if (ListData instanceof Array && ListData.length > 0) {

        //rootList 根结点集合  nodeList 子结点集合
        var rootList = [],
          nodeList = [],
          allChildren = [];
        var allnode;
        // 分离出 根结点和子结点集合
        ListData.forEach((node, index) => {
          node["path"] = node["HTTPURL"];
          if (node.MenuID < 0)
            node["icon"] = "md-document"; //node["MenuIconFile"]
          else
            node["icon"] = "md-folder"; //node["MenuIconFile"]
          node["title"] = node["MenuName"];
          // if (node["title"].length > 8)
          //   node["titletip"] = node["title"].substring(0, 6) + "……";
          // else
          node["titletip"] = node["title"]
          node["name"] = node["MenuID"];

          allnode = node;
          //id  和text为 必须设置因为我遇到的问题是combotree绑定数据显示乱码
          if (node[parentIdName] == rootParentIdValue) {
            rootList.push(node);
          } else {
            nodeList.push(node);
          }
        });
        //递归增加子结点 rootNodeList根结点集合， //子结点集合  闭包结构
        function childrenNodeAdd(rootNodeList, childrenList) {
          if (childrenList.length > 0) { //  如果没有子结点了结束递归
            //遍历根结点集合在 子结点中查找其自身的子结点并添加根结点对应的子结点
            rootNodeList.forEach((rootNode, index) => { //遍历所有子结点
              rootNodeList[index]["children"] = [];
              childrenList.forEach((childrenNode, childrenIndex) => {

                if (parentIdName in childrenNode && rootNode[nodeIdName] == childrenNode[parentIdName]) { //跟结点的id 等于子结点的父类id
                  rootNodeList[index]["children"].push(childrenNode); //添加对应结点归为子结点
                  if (allChildren.length > 0)
                    allChildren.push(allnode); // 缓存所有已经添加过的对象
                }
              });
              var childrenNodeList = [] //一级结点添加完以后看是否还有剩余的子结点
              //筛选器剩余的子结点

              childrenList.forEach((childrenNode, childrenIndex) => {
                var isAdd = true
                allChildren.forEach((node, index) => {
                  if (node == childrenNode) {
                    isAdd = false;
                  }
                });
                if (isAdd) {
                  childrenNodeList.push(childrenNode);
                }
              });

              childrenNodeAdd(rootNodeList[index]["children"], childrenNodeList); //剩余子结点继续递归执行 每次递归一次就表示结点增加一级。
            })
          }
        }
        if (nodeList.length > 0 && rootList.length > 0) {
          childrenNodeAdd(rootList, nodeList);
          state.menuListTree = rootList;
        } else if (rootList.length > 0) {
          state.menuListTree = rootList;
        } else {
          state.menuListTree = [];
          state.menuListTree = localStorage.ListData;
        }
      } else {
        state.menuListTree = [];
        state.menuListTree = localStorage.ListData;
      }
      //if(rootList){

      //}


    }

  },

  actions: {},
  modules: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/Common/Store.js